module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "content-heading"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-success btn-noborder float-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openCreateUserModal
    }
  }, [_c('i', {
    staticClass: "fa fa-plus mr-5"
  }), _vm._v("Nieuwe Gebruiker\n    ")]), _vm._v(" "), _c('i', {
    staticClass: "si si-people mr-5"
  }), _vm._v(" Gebruikers\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.users), function(user) {
    return _c('div', {
      key: user.id,
      staticClass: "col-md-6 col-xl-3"
    }, [_c('div', {
      staticClass: "block block-link-shadow text-center"
    }, [_c('div', {
      staticClass: "block-content block-content-full block-sticky-options pt-30"
    }, [_c('div', {
      staticClass: "block-options"
    }, [_c('b-dropdown', {
      staticClass: "dropdown-no-btn",
      attrs: {
        "right": ""
      }
    }, [_c('template', {
      slot: "button-content"
    }, [_c('i', {
      staticClass: "fa fa-fw fa-ellipsis-v"
    })]), _vm._v(" "), (user.role === 'orderpicker') ? _c('b-dropdown-item', {
      on: {
        "click": function($event) {
          _vm.openHourRegistrationModal(user.id)
        }
      }
    }, [_c('i', {
      staticClass: "si si-clock mr-5"
    }), _vm._v("Bekijk uren registratie\n        ")]) : _vm._e(), _vm._v(" "), _c('b-dropdown-item', {
      on: {
        "click": function($event) {
          _vm.deleteUser(user.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-exclamation-circle mr-5"
    }), _vm._v("Verwijder gebruiker\n        ")])], 2)], 1), _vm._v(" "), _c('img', {
      staticClass: "img-avatar",
      attrs: {
        "src": user.avatar_url,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "block-content block-content-full block-content-sm bg-body-light"
    }, [_c('div', {
      staticClass: "font-w600 mb-5"
    }, [_vm._v(_vm._s(user.username))])]), _vm._v(" "), _c('div', {
      staticClass: "block-content"
    }, [_c('div', {
      staticClass: "row items-push text-center"
    }, [_c('div', {
      staticClass: "col-6"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "font-size-sm text-muted"
    }, [_vm._v(_vm._s(user.role))])]), _vm._v(" "), _c('div', {
      staticClass: "col-6"
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "font-size-sm text-muted"
    }, [_vm._v(_vm._s(_vm._f("moment")(user.created_at, 'calendar')))])])])])])])
  }), 0), _vm._v(" "), (_vm.showCreateUserModal) ? _c('create-new-user-modal', {
    on: {
      "userCreated": _vm.loadUsers,
      "close": function($event) {
        _vm.showCreateUserModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showHourRegistrationModal) ? _c('hour-registration-modal', {
    attrs: {
      "userId": _vm.selectedUserId
    },
    on: {
      "close": function($event) {
        _vm.showHourRegistrationModal = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-5"
  }, [_c('i', {
    staticClass: "si si-badge fa-2x"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-5"
  }, [_c('i', {
    staticClass: "si si-user-follow fa-2x"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d901ad4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/users/UsersPage.vue
// module id = 739
// module chunks = 1